"use client";

import type { Dialog } from "radix-ui";
import { type Dispatch, type SetStateAction, createContext, useContext } from "react";

interface DialogContextProps extends Dialog.DialogProps {
	forceOpen: boolean;
	setForceOpen: Dispatch<SetStateAction<boolean>>;
}

export const DialogContext = createContext<DialogContextProps | null>(null);

export function useDialogContext() {
	const context = useContext(DialogContext);

	return context;
}
